module.exports = __webpack_public_path__ + "static/media/passion.b16fd99f.svg";